export { BetSlipRequest } from './BetSlipRequest';